import type { TOC } from '@ember/component/template-only';
import { hash } from '@ember/helper';

import styles from './breadcrumb.module.css';
import PrismBreadcrumbItem from './breadcrumb/item.gts';

interface PrismBreadcrumbSignature {
  Blocks: {
    default: [
      {
        item: typeof PrismBreadcrumbItem;
      },
    ];
  };
}

const PrismBreadcrumb = <template>
  <ol class={{styles.list}}>
    {{yield (hash item=PrismBreadcrumbItem)}}
  </ol>
</template> satisfies TOC<PrismBreadcrumbSignature>;

export default PrismBreadcrumb;
